module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Cheese-840edc6e14e337087bec3c84e216594d.svg";